import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// Constants
import { WEB_SERVICE } from "../../config/constants";
// Components
import {
  Body,
  Header,
  LogoImg,
  OkContainer,
  WrongContainer,
  CoachImg,
  OkContainerInfo,
  WrongContainerInfo,
  Title,
  Text,
  DeepLink,
} from "./styles";
import Loader from "../loader";
import UseFetch from "../../config/useFetch";
// Assets
import RGSLogo from "../../assets/rgs_plus_logo.png";
import CoachOk from "../../assets/coach_ok.png";
import CoachWrong from "../../assets/coach_wrong.png";

const VerifyEmailUI = () => {
  // loading | verified | expired | error
  const [status, setStatus] = useState("loading");
  const [token] = useState(window.location.pathname.split("/")[2]);

  const [t] = useTranslation("global");

  // Verify email Api
  useEffect(() => {
    const handleSetToken = async () => {
      if (!token) return setStatus("expired");

      await UseFetch("post", `${WEB_SERVICE}/patient/verify-email`, new AbortController(), {
        token,
      })
        // El backend responde 200 con emailVerified:false cuando el enlace esta
        // caducado o es invalido. Si en cambio salta una excepcion, el fallo es
        // nuestro (401, 500, red): no hay que decirle al usuario que su enlace
        // ha caducado, porque no es verdad y volveria a pedir otro correo.
        .then(({ data }) => setStatus(data.emailVerified ? "verified" : "expired"))
        .catch((error) => {
          console.error("Verify email: ", error);
          setStatus("error");
        });
    };
    handleSetToken();

    return () => setStatus("loading");
  }, [token]);

  const getDeviceType = () => {
    const ua = navigator.userAgent || window.opera;
    const isAndroid = /android/i.test(ua);
    const isIOS = /iPhone|iPad|Macintosh|iPod/i.test(ua);
    return isAndroid || isIOS;
  };

  const renderCoachOK = () => {
    return (
      <OkContainer>
        <CoachImg src={CoachOk} alt="coach-ok" />
        <OkContainerInfo>
          <Title>{t("verifiedAccountTitle")}</Title>
          <Text>{t("verifiedAccountPrompt")}.</Text>
          {getDeviceType() && <DeepLink href="unitydl://mylink?rgs_account_verified">{t("goBackToRGS")}</DeepLink>}
        </OkContainerInfo>
      </OkContainer>
    );
  };

  const renderCoachWrong = () => {
    return (
      <WrongContainer>
        <WrongContainerInfo>
          <Title>{t("expiredLinkTitle")}</Title>
          <Text>{t("expiredLinkPrompt")}.</Text>
        </WrongContainerInfo>
        <CoachImg src={CoachWrong} alt="coach-wrong" />
      </WrongContainer>
    );
  };

  const renderError = () => {
    return (
      <WrongContainer>
        <WrongContainerInfo>
          <Title>{t("genericErrorTitle")}</Title>
          <Text>{t("genericErrorPrompt")}.</Text>
        </WrongContainerInfo>
        <CoachImg src={CoachWrong} alt="coach-wrong" />
      </WrongContainer>
    );
  };

  return (
    <Body>
      <Header marginBottom={status === "verified" ? "16px" : "32px"}>
        <LogoImg src={RGSLogo} alt="logo" />
      </Header>
      {status === "loading" ? (
        <Loader />
      ) : status === "verified" ? (
        renderCoachOK()
      ) : status === "expired" ? (
        renderCoachWrong()
      ) : (
        renderError()
      )}
    </Body>
  );
};

export default VerifyEmailUI;
